import axios from 'axios';

const API_URL = 'https://psri.k3lpaser.com/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Tambah token ke setiap request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('psri_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response error
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('psri_token');
      localStorage.removeItem('psri_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
